import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StudentCard.css";

class Profile extends Component {
  render() {
    const { classes, student } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>General</h3>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Scholarship Type</b>
            <div>{student.scholarshipType}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Gender</b>
            <div>{student.gender}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Admission Date</b>
            <div>{student.admissionDate}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Date of Birth(AD)</b>
            <div>{student.dob_in_AD}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Date of Birth(BS)</b>
            <div>{student.dob_in_BS}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Email Address</b>
            <div>{student.email}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Mobile Number</b>
            <div>{student.phoneNo}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Blood Group </b>
            <div>{student.bloodGroup}</div>
          </ListItem>
        </div>{" "}
      </div>
    );
  }
}

export default withStyles(useStyles)(Profile);
